
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alu/doors/reynaers/[slug]",
      function () {
        return require("private-next-pages/alu/doors/reynaers/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alu/doors/reynaers/[slug]"])
      });
    }
  